import Axios from 'axios';
import { apiUrl } from 'app/environment-variables';
import { DisclaimerI } from './models';

export const getDisclaimer = () =>
  Axios.get<CommonTypes.RestfulResponse<DisclaimerI>>(`${apiUrl}/disclaimer`);
